<template>
    <div class="SingleSelectOptions">
        <div class="SingleSelectOptions__options" @scroll="emitScroll">
            <DropdownSelectOption
                v-for="(option, index) of options"
                :key="index"
                :disabled="isDisabledOption(option)"
                @click="selectOption(option)"
            >
                <span>{{ option.label }}</span>
            </DropdownSelectOption>
            <template v-if="$slots.afterOptions">
                <slot name="afterOptions" />
            </template>
        </div>
    </div>
</template>
<script lang="ts">
    import { PropType } from 'vue';

    import { debounce } from 'lodash';
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import DropdownSelectOption from './DropdownSelectOption.vue';
    import { DropdownOption, IsDisabledOption } from './types';

    // PRODUCT-26110 Task 13 (Finding 4): declares every event this component `$emit`s
    // -- without a declared `emits`, Vue 3 warns "Component emitted event 'scroll' but
    // it is neither declared in the emits option nor as an 'onScroll' prop" every time
    // it fires (seen x31 in one QA session).
    @Component({
        components: {
            DropdownSelectOption,
        },
        emits: [ 'select', 'scroll' ],
    })
    export default class SingleSelectOption extends Vue {
        @Prop({ type: Array, default: () => [] })
        private options!: DropdownOption[];

        @Prop({ type: Function as PropType<IsDisabledOption>, default: () => false })
        private isDisabledOption!: IsDisabledOption;

        private debouncedEmitScroll = debounce((event: Event) => {
            this.$emit('scroll', event);
        }, 50);

        private selectOption(option: DropdownOption): void {
            this.$emit('select', option);
        }

        private emitScroll(event: Event): void {
            this.debouncedEmitScroll(event);
        }
    }
</script>
